import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=cfeff598&scoped=true"
import script from "./DesktopNavigation.js?vue&type=script&lang=js&external"
export * from "./DesktopNavigation.js?vue&type=script&lang=js&external"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=cfeff598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeff598",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default,HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
